import { message } from 'antd';
import { RecordInfoDrawer } from 'components/RecordInfoDrawer';
import { TableHeader } from 'components/TableHeader';
import {
  DELETE_ERROR,
  FETCH_ERROR,
  REQUEST_LOADING,
  SUCCESS_DELETE,
} from 'constants/alerts';
import { useDocumentTitle } from 'hooks/useDocumentTitle';
import { useDrawers } from 'hooks/useDrawers';
import { useHeaderChanger } from 'hooks/useHeaderChanger';
import { usePagination } from 'hooks/usePagination';
import React, { useEffect, useState } from 'react';
import { KATOService } from 'services/KATOService';
import { UGDService } from 'services/UGDService';
import { UGDForm } from './UGDForm';
import { UGDTable } from './UGDTable';

function UGD() {
  useDocumentTitle('УГД по РК');
  const [items, setItems] = useState([]);
  const [regions, setRegions] = useState([]);
  const [loading, setLoading] = useState(false);
  const { setCount } = useHeaderChanger('УГД по РК');
  const { page, totalRows, perPage, setTotalRows, setPagination } =
    usePagination();
  const {
    state: { drawerVisible, formIsActive, activeRecord },
    openDrawer,
    closeDrawer,
    openCreateForm,
    openEditForm,
    closeForm,
  } = useDrawers();

  useEffect(() => {
    fetchRegions();
  }, []);

  useEffect(() => {
    fetchItems();
  }, [page, perPage]);

  const fetchItems = async () => {
    if (!page || !perPage) {
      return;
    }

    setLoading(true);

    try {
      const { items, total } = await UGDService.getUGD(page, perPage);

      setItems(items);
      setCount(total);
      setTotalRows(total);
    } catch (err) {
      message.error(FETCH_ERROR);
    } finally {
      setLoading(false);
    }
  };

  const fetchRegions = async () => {
    try {
      const kato = await KATOService.getAllKATO();

      setRegions(kato);
    } catch (err) {
      message.error('Не удалось подгрузить регионы');
    }
  };

  const handleDelete = async () => {
    const hide = message.loading(REQUEST_LOADING);

    try {
      const isDeleted = await UGDService.deleteUGD(activeRecord.id);

      if (isDeleted) {
        closeDrawer();
        fetchItems();
        message.success(SUCCESS_DELETE);
      }
    } catch (err) {
      message.error(DELETE_ERROR);
    } finally {
      hide();
    }
  };

  return (
    <>
      <TableHeader onCreate={openCreateForm} pageId="ugd" />

      <RecordInfoDrawer
        record={activeRecord}
        drawerTitle={activeRecord?.name}
        recordFields={[
          { label: 'Код НУ для зачисления в бюджет', key: 'number' },
          { label: 'Наименование бенефициара', key: 'name' },
          { label: 'БИН бенефициара', key: 'requisite' },
          {
            label: 'Город',
            key: 'region',
            computedValue: activeRecord?.region?.parent
              ? activeRecord?.region.parent?.name_rus
              : activeRecord?.region?.name_rus,
          },
        ]}
        isVisible={drawerVisible}
        onClose={closeDrawer}
        onEdit={openEditForm}
        onDelete={handleDelete}
        deleteConfirmText="Вы точно хотите удалить эту запись ?"
        pageId="ugd"
      />

      <UGDTable
        items={items}
        loading={loading}
        current={page}
        pageSize={perPage}
        totalRows={totalRows}
        onRowClick={openDrawer}
        onChange={setPagination}
      />

      <UGDForm
        isActive={formIsActive}
        regions={regions}
        initialValues={activeRecord}
        onSuccess={fetchItems}
        onClose={closeForm}
      />
    </>
  );
}

export { UGD };
